import * as React from 'react'

import { TableActionButtonInterface } from '@/modules/drivers/types/table'
import Tooltip from '../ToolTip'

const TableActionBar = ({
  actions,
  children,
}: {
  actions: TableActionButtonInterface[]
  children?: React.ReactNode
}) => {
  return (
    <div className="tw-flex tw-w-full tw-items-center tw-justify-between tw-gap-4 tw-rounded-t-lg tw-border-b-2 tw-border-primary tw-bg-content-background tw-py-[13px] tw-pl-4 tw-pr-4">
      <div className="tw-flex tw-items-center tw-gap-5">
        {actions.map((a, index) => (
          <Tooltip key={index} text={a.tooltip} disabled={a.disabled}>
            <img
              onClick={a.action}
              className="tw-h-4 tw-w-4"
              src={a.icon}
              alt={a.tooltip}
            ></img>
          </Tooltip>
        ))}
      </div>
      {children}
    </div>
  )
}

export default TableActionBar
